import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const withdrawalPagoMovilService = async data => {
  return privateRequest.post(`${ConfEnv.API_WALLET.URL_WITHDRAWAL}`, data);
};
